module.exports = __webpack_public_path__ + "static/media/FarmlandScene-menuicon_OffState.c3ba4fdd.png";